import './components/swiper.js';
import './components/scroll.js';
import './components/modal.js';
import './components/validate.js';
import './components/accordion.js';
